<template>
  <div class="body">
    <van-nav-bar title="收货地址" left-text left-arrow @click-left="onClickLeft" class="topNav"/>
    <div class="content animated fadeInRight fast" v-if="hasData">
      <van-radio-group v-model="checkId">
        <div class="itemWrap" v-for="item in list" :key="item.address_id">
          <div class="itemContent">
            <div class="info">
              <p class="name">{{item.name}}</p>
              <p class="phone">{{item.phone}}</p>
            </div>
            <p class="address">{{item.province}}{{item.city}}{{item.region}}{{item.detail}}</p>
          </div>
          <div class="itemFooter">
            <van-radio
              :name="item.address_id"
              class="itemSel"
              checked-color="#e9aea8"
              @click="changeAddress(item.address_id)"
            >{{item.address_id==checkId?"默认":"选择"}}</van-radio>
            <div class="footerTool">
              <p @click="editAddress(item.address_id)">
                <i class="iconfont icon-bianji1"/>编辑
              </p>
              <p @click="deleteAddress(item.address_id)">
                <i class="iconfont icon-shanchu"/>删除
              </p>
            </div>
          </div>
        </div>
      </van-radio-group>
    </div>
    <div v-if="!hasData">
      <NoData msg="亲，您还没有收货地址"/>
    </div>
    <div class="footer">
      <button class="addNew" @click="addAddress()">添加新地址</button>
    </div>
  </div>
</template>

<script>
import NoData from "@/components/NoData.vue";
import {
  GetAddress,
  changeDefaultAddress,
  deleteAddress
} from "../../apis/https.js";
import { getLocalStorage } from "../../utils/storage.js";
import { RadioGroup, Radio, Dialog } from "vant";
import Vue from "vue";
Vue.use(RadioGroup)
  .use(Radio)
  .use(Dialog);
export default {
  components: {
    NoData
  },
  data() {
    return {
      hasData: false,
      checked: true,
      checkId: 0,
      list: [],
      token: ""
    };
  },
  created() {
  },
  activated() {
    this.token = getLocalStorage("login_token");
    this.GetAddress();
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    GetAddress() {
      GetAddress(this.token).then(res => {
        if (res.code == 1) {
          let data = res.data;
          if (data.list.length > 0) {
            this.hasData = true;
            //赋值
            this.checkId = data.default_id;
            this.list = [];
            for (let i in data.list) {
              this.list.push({
                address_id: data.list[i].address_id,
                name: data.list[i].name,
                phone: data.list[i].phone,
                province: data.list[i].region.province,
                city: data.list[i].region.city,
                region: data.list[i].region.region,
                detail: data.list[i].detail
              });
            }
          }
        }
      }).catch(e=>{});
    },
    addAddress() {
      this.$router.push("/pages/address/add");
    },
    changeAddress(id) {
      changeDefaultAddress(id, this.token).then(res => {
        if (res.code != 1) {
          this.$toast.fail("更改失败");
        }
      });
    },
    deleteAddress(id) {
      Dialog.confirm({
        title: "提示",
        message: "您确定要移除当前的收货地址吗？"
      })
        .then(() => {
          // on confirm
          deleteAddress(id, this.token).then(res => {
            if (res.code == 1) {
              this.GetAddress();
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    editAddress(id) {
      this.$router.push({
        name: "editaddress", // 路由的名称
        query: {
          id: id
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../style/skin.less");
.body {
  background: #f4f8fb;
  min-height: 100vh;
  overflow: hidden;
  .topNav {
    position: fixed;
    width: 100%;
    top: 0px;
    i {
      color: #323233 !important;
    }
  }
  .content {
    margin-top: 46px;
    margin-bottom: 46px;
    .itemWrap {
      padding: 10px;
      background: @white;
      margin-bottom: 12px;
      .itemContent {
        padding-bottom: 5px;
        border-bottom: 1px solid @lightLine;
        .info {
          display: flex;
          .name {
            font-size: 16px;
            color: @darkP;
          }
          .phone {
            margin-left: 10px;
            font-size: 16px;
            color: @darkP;
          }
        }
        .address {
          font-size: 14px;
          color: @lightP;
        }
      }
      .itemFooter {
        padding-top: 10px;
        overflow: hidden;
        .itemSel {
          font-size: 14px;
          float: left;
          height: 25px;
          line-height: 25px;
        }
        .footerTool {
          float: right;
          display: flex;
          flex-wrap: nowrap;
          p {
            font-size: 14px;
            margin-left: 10px;
            height: 25px;
            line-height: 25px;
            i {
              display: inline-block;
              padding: 0px 3px;
              font-size: 16px;
            }
          }
        }
      }
    }
  }
  .footer {
    position: fixed;
    bottom: 0px;
    left: 0px;
    right: 0px;
    height: 46px;
    z-index: 11;
    box-shadow: 1px 5px 15px rgba(50, 50, 50, 0.3);
    background: @white;
  }
  .addNew {
    width: 100%;
    // background: linear-gradient(to right, #fa1e8c 0, #fc1e56 100%);
    background: @btn;
    border: 0px;
    color: @white;
    text-align: center;
    line-height: 46px;
    font-size: 14px;
    height: 46px;
    float: left;
  }
}
</style>